import React, { useEffect, useMemo } from 'react'
import Back from '../../features/back/Back'
import CustomButton from '../../features/customButton/ui/main/CustomButton'
import { compilationScrollbarSettings, gifts } from '../../../constants/copyright'
import { safeHTML } from '../../../utils/safeHTML'
import { Scrollbar } from 'react-scrollbars-custom'
import { useContent } from '../../../redux/reducer/content'
import { useUser } from '../../../redux/reducer/user'
import { useModal } from '../../../hooks/useModal'
import useStateControls from '../../../hooks/useStateControls'
import { useTranslation } from '../../../translations'
import { fromTimeStampFull } from '../../../utils/helpers/helpers'
import { useLanguageControls } from '../../../hooks/useLanguageControls'
import { useGoldenAppleUrl } from '../../../hooks/useGoldenAppleUrl'
import classNames from 'classnames'
import AppLoader from '../../features/appLoader/AppLoader'
import { useRequestsHandlerData } from '../../../hooks/useRequestsHandlerData'
import { useRequests } from '../../../redux/reducer/requests'

const Gifts = React.forwardRef(function Gifts({ callbacks }, ref) {
  const { prizes: { buyPrizes } = {} } = useContent()
  const { profile } = useUser()
  const { title, modalButtons, myStub } = gifts
  const { addModal } = useModal()

  const state = 'my'
  const {
    authData: { isWeb },
  } = useRequests()
  const { setState: setAppState } = useStateControls()
  const { t } = useTranslation()
  const { isArabic } = useLanguageControls()
  const goldenAppleUrl = useGoldenAppleUrl()

  const prizesList = useMemo(() => {
    if (!profile || !buyPrizes) return []

    return profile.prizes ?? []
  }, [profile, buyPrizes])

  const toMain = () => {
    setAppState('main')
  }

  const prizeCallback = (item) => {
    addModal({
      type: 'winModal',
      props: {
        ...item,
        mod: 'gifts',
        img: item.image,
        buttons: modalButtons,
        noXP: true,
        title: item.title,
        linkBtn: item.link || goldenAppleUrl,
        expired_at: item.promocode_end_date,
      },
    })
  }

  const isPending = useRequestsHandlerData([
    {
      address: 'requestsUserPrizes',
    },
  ])

  useEffect(() => {
    callbacks.getUserPrizes()
  }, [])

  return (
    <div
      className={'gifts'}
      ref={ref}
    >
      <div className={'gifts__content'}>
        <div className={`gifts__head ${isWeb ? '' : 'app'}`}>
          <Back onClick={toMain} />
          <h2 className={'gifts__title'}>{safeHTML(t(title))}</h2>
        </div>
        {!!prizesList.length ? (
          <div className={classNames('gifts__list', { 'gifts__list-no-tabs': true })}>
            <Scrollbar {...compilationScrollbarSettings}>
              {prizesList?.map?.((item, index) => {
                const { image: img, title, id, promocode_end_date } = item

                return (
                  <div
                    className={'gifts__item'}
                    key={`prize-${id}-${index}`}
                  >
                    {promocode_end_date && (
                      <div className={'gifts__item-date'}>
                        <div className={'gifts__item-text'}>
                          {safeHTML(
                            t('other.expiredAtWithValue', {
                              value: fromTimeStampFull(promocode_end_date, isArabic),
                            }),
                          )}
                        </div>
                      </div>
                    )}
                    <div className={'gifts__item-image'}>
                      <img
                        src={img}
                        alt={title}
                      />
                    </div>
                    <div className={'gifts__item-title'}>{safeHTML(title)}</div>
                    <CustomButton
                      className={'gifts__item-price'}
                      text={{ my: t('gifts.more') }[state]}
                      onClick={() => prizeCallback(item)}
                    />
                  </div>
                )
              })}
            </Scrollbar>
          </div>
        ) : (
          <div className={'gifts__stub'}>
            <h2 className={'gifts__stub-title'}>{safeHTML(t(myStub?.title))}</h2>
            <span className={'gifts__stub-text'}>{safeHTML(t(myStub?.text))}</span>
          </div>
        )}
      </div>

      {isPending && <AppLoader />}
    </div>
  )
})
export default Gifts
Gifts.propTypes = {}
